$(document).ready(function(){
	new WOW().init();
 
	$('#images_fl').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		smartSpeed: 1000,
		autoplay:false,
		nav:false,
		pagination:true,  dots: false,
		navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"],
		items: 1,
	    responsive:{
	        
	        
	    }
	});
  
  $(".locations_zig .header_port a").on("click",function() {


		if (!$(this).closest(".locations_zig").hasClass("open")) {
			$(".locations_zig .body_port").slideUp();
			$(".locations_zig").removeClass("open");
			$(this).closest(".locations_zig").find(".body_port").slideToggle();
			$(this).closest(".locations_zig").toggleClass("open");
		} else {
			$(".locations_zig .body_port").slideUp();
			$(".locations_zig").removeClass("open");
		}
	});
	
	//.owl-carousel .owl-dot, .owl-carousel .owl-nav .owl-next, .owl-carousel .owl-nav .owl-prev
	$(document).on("click",".prev_img",function(){
		$( "#lookbook .owl-nav .owl-prev" ).trigger( "click" );
	});
	$(document).on("click",".next_img",function(){
		$( "#lookbook .owl-nav .owl-next" ).trigger( "click" );
	});
	
  //.owl-carousel .owl-dot, .owl-carousel .owl-nav .owl-next, .owl-carousel .owl-nav .owl-prev
	$(document).on("click",".prev_img",function(){
		$( "#images_fl .owl-nav .owl-prev" ).trigger( "click" );
	});
	$(document).on("click",".next_img",function(){
		$( "#images_fl .owl-nav .owl-next" ).trigger( "click" );
	});
  //.owl-carousel .owl-dot, .owl-carousel .owl-nav .owl-next, .owl-carousel .owl-nav .owl-prev
	$(document).on("click",".prev_img",function(){
		$( "#lookbook-mobile .owl-nav .owl-prev" ).trigger( "click" );
	});
	$(document).on("click",".next_img",function(){
		$( "#lookbook-mobile .owl-nav .owl-next" ).trigger( "click" );
	});
  
  //.owl-carousel .owl-dot, .owl-carousel .owl-nav .owl-next, .owl-carousel .owl-nav .owl-prev
	$(document).on("click",".prev_img",function(){
		$( "#likesection .owl-nav .owl-prev" ).trigger( "click" );
	});
	$(document).on("click",".next_img",function(){
		$( "#likesection .owl-nav .owl-next" ).trigger( "click" );
	});
  
	$('#collection').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		smartSpeed: 1000,
		autoplay:false,
		nav:true,
		pagination:true,  dots: false,
		navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"],
		items: 1,
	    responsive:{
	        
	        
	    }
	}); 
	
	$('#mostpopular').owlCarousel({
	     margin:0,
	     loop:false,
		 slideSpeed : 300,
		 paginationSpeed : 400,
		 smartSpeed: 1000,
		 center: true,
		 autoplay:false,
		 nav:true,
		 transitionStyle : "fade",
		 pagination:true,  dots: false,
		 navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"],
		 items: 2,
	     responsive:{
           0:{
	            items:1,
          	center: false,
          	margin:5,
	        },
	        480:{
	            items:1,
          	center: false,
          	margin:5,
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:2
	        },
	        1100:{
	            items:2
	        }
    }
        
	});
  /*===================================*
	 announcment bar 
	*===================================*/
	$('#announcment').owlCarousel({
	     margin:0,
	     loop:true,
		 slideSpeed : 300,
		 paginationSpeed : 400,
		 smartSpeed: 1000,
		 center: false,
		 autoplay:false,
		 nav:false,
         mouseDrag: false,
		 transitionStyle : "fade",
		 pagination:true,  dots: false,
		 navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"],
	     responsive:{
           0:{
	            items:1,
             	autoplay:true
	        },
	        480:{
	            items:1,
              	autoplay:true
	        },
	        700:{
	            items:1
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:3
	        }
    }
        
	});
  /*===================================*
	 home-icons 
	*===================================*/
	$('#home-icons').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		 paginationSpeed : 400,
		 smartSpeed: 1000,
		 center: false,
		 autoplay:false,
		 nav:false,
         mouseDrag: false,
		 transitionStyle : "fade",
		 pagination:true,  dots: false,
		 navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"],
	     responsive:{
           0:{
	            items:2,
             	autoplay:true
	        },
	        480:{
	            items:2,
              	autoplay:true
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:4
	        },
	        1100:{
	            items:4
	        }
    }
        
	});
  /*===================================*
	 sale section 
	*===================================*/
	$('#salesection').owlCarousel({
	     margin:10,
	     loop:true,
		 slideSpeed : 300,
		 paginationSpeed : 400,
		 smartSpeed: 1000,
		 center: false,
		 autoplay:false,
		 nav:false,
         mouseDrag: false,
		 transitionStyle : "fade",
		 pagination:true,  dots: false,
		 navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"],
	     responsive:{
           0:{
	            items:2,
             	autoplay:true
	        },
	        480:{
	            items:2,
              	autoplay:true
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:4
	        },
	        1100:{
	            items:4
	        }
    }
        
	});
  /*===================================*
	 preorder section 
	*===================================*/
	$('#preorder-section').owlCarousel({
	     margin:12,
	     loop:true,
		 slideSpeed : 300,
		 paginationSpeed : 400,
		 smartSpeed: 1000,
		 center: false,
		 autoplay:false,
		 nav:false,
         mouseDrag: false,
		 transitionStyle : "fade",
		 pagination:true,  dots: false,
		 navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"],
	     responsive:{
           0:{
	            items:2,
             	autoplay:true
	        },
	        480:{
	            items:2,
              	autoplay:true
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:4
	        },
	        1100:{
	            items:4
	        }
    }
        
	});
	 /*===================================*
	 LOOK BOOK 
	*===================================*/
	$('#lookbook').owlCarousel({
	     margin:0,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		smartSpeed: 1000,
		autoplay:false,
		nav:false,
      	
		pagination:true,  dots: true,
		navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"],
		items: 1,
	    responsive:{
	        
	        
	    }
	}); 
  
  /*===================================*
	 LOOK BOOK MOBILE
	*===================================*/
	$('#lookbook-mobile').owlCarousel({
	     margin:10,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		smartSpeed: 1000,
		autoplay:false,
		nav:false,
		pagination:true,  dots: true,
		navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"],
		items: 1,
	    responsive:{
	        
	        
	    }
	}); 
  /*===================================*
	 LIKE SECTION OF PRODUCT PAGE
	*===================================*/
  
  
	$('#likesection').owlCarousel({
	     margin:30,
	     loop:true,
	     stagePadding: 0,
		 slideSpeed : 300,
		 paginationSpeed : 400,
		 smartSpeed: 1000,
		 center: false,
		 autoplay:false,
      	 mouseDrag: false,
		 nav:false,
		 transitionStyle : "fade",
		 pagination:true,  dots: false,
		 navText: ["<i class='fa fa-long-arrow-left'></i>","<i class='fa fa-long-arrow-right'></i>"],
	    responsive:{
				0:{
					items:2,
                  	mouseDrag: true,
                  	autoplay:true,
				},
				600:{
					items:2,
                  	mouseDrag: true,
                  	autoplay:true,
				},
				700:{
					items:2
				},
				1000:{
					items:4
				}
			}
	});
	
/*===================================*
	 CART PAGE
	*===================================*/
  $('#relatedcart').owlCarousel({
			margin:10,
			loop:true,
			slideSpeed : 300,
			paginationSpeed : 400,
			mouseDrag: false,
			autoplay:false,
			nav:false,
  			lazyLoad: true,
			pagination:false,  dots: false,
			navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
			responsive:{
				0:{
					items:2,
                  	autoplay:true,
                  	mouseDrag:true,
                  	nav:false
				},
				600:{
					items:2,
                  	autoplay:true,
                  	mouseDrag:true,
                  	nav:false
				},
				990:{
					items:4
				},
				1000:{
					items:4
				}
			}
		});
	//productdetailpage///
	 var galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
    var galleryTop = new Swiper('.gallery-top', {
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });
    
   /*===================================*
	 PRODUCT SIZE SWITCH 
	*===================================*/
	$('.product_size_switch span').on("click", function() {
		$(this).siblings(this).removeClass('active').end().addClass('active');
	});
	
	 /*===================================*
	 PRODUCT quantity
	*===================================*/
	
	$('.plus').on('click', function() {
		if ($(this).prev().val()) {
			$(this).prev().val(+$(this).prev().val() + 1);
		}
	});
	$('.minus').on('click', function() {
		if ($(this).next().val() > 1) {
			if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
		}
	});
  
  	 /*===================================*
	 PRICE FILTER JS
	*===================================*/
	$('#price_filter').each( function() {
		var $filter_selector = $(this);
		var a = $filter_selector.data("min-value");
		var b = $filter_selector.data("max-value");
		var c = $filter_selector.data("price-sign");
		$filter_selector.slider({
			range: true,
			min: $filter_selector.data("min"),
			max: $filter_selector.data("max"),
			values: [ a, b ],
			slide: function( event, ui ) {
				$( "#flt_price" ).html( c + ui.values[ 0 ] + " - " + c + ui.values[ 1 ] );
				$( "#price_first" ).val(ui.values[ 0 ]);
				$( "#price_second" ).val(ui.values[ 1 ]);
			}
		});
		$( "#flt_price" ).html( c + $filter_selector.slider( "values", 0 ) + " - " + c + $filter_selector.slider( "values", 1 ) );
	});
	
	 /*===================================*
	 PRODUCT callups
	*===================================*/
	
	$(".installation_portions .intallation_head a").on("click",function(){
		
		
		if(!$(this).closest(".installation_portions").hasClass("open"))
		{
			$(".installation_portions .installation_body").slideUp();
			$(".installation_portions").removeClass("open");
			$(this).closest(".installation_portions").find(".installation_body").slideToggle();
			$(this).closest(".installation_portions").toggleClass("open");
		}
		else
		{
			$(".installation_portions .installation_body").slideUp();
			$(".installation_portions").removeClass("open");
		}
	});
	 $('.same_height_container').each(function(){  
      
      // Cache the highest
      var highestBox = 0;
      
      // Select and loop the elements you want to equalise
      $('.same_height', this).each(function(){
        
        // If this box is higher than the cached highest then store it
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
            
      // Set the height of all those children to whichever was highest 
      $('.same_height',this).height(highestBox);
                    
    }); 
  




    /*collectionpage-click filter*/           
  let FilterButton=document.getElementById("FilterButton");
            FilterButton.addEventListener('click',FilterShow);
            function FilterShow()
            {
                document.getElementById("FilterBlog").style.display="block";
            }
            let close=document.getElementById("close");
            close.addEventListener('click',CloseFilter);
            function CloseFilter()
            {
                document.getElementById("FilterBlog").style.display="none";
            }
	
	 
	

	

	
});